import { isEmpty } from 'underscore';
import { AUDIO_FILE } from '@shoflo/polymer';
import { queueSceneLayoutSelector } from '@studio/program';

import {
  getVisualMediaSourcesInProgram,
  isVisualMediaSource
} from '@studio/sources';
import queueStageLayout from './queueStageLayout';
import { BROADCAST_TOGGLE_STAGE_SOURCE } from 'actions/Types';
import { batch } from 'react-redux';

export default source => {
  return (dispatch, getState) => {
    const {
      broadcastSources: { sources: broadcastSources },
      stagedSources: {
        sources: currentlyStagedSources,
        sceneLayout: stagedSceneLayout
      }
    } = getState();

    const stagedSources = { ...(currentlyStagedSources || {}) };
    const { _id: sourceId, type: sourceType } = source;

    const isAudioSource = sourceType === AUDIO_FILE;

    const stagedSourceIds = Object.keys(stagedSources).filter(
      sourceId => stagedSources[sourceId]
    );

    const [stagedVisualMediaSource] = getVisualMediaSourcesInProgram(
      stagedSourceIds,
      broadcastSources
    );

    const isVisualMediaSourceStaged = !isEmpty(stagedVisualMediaSource);

    const isStaged = stagedSources[sourceId];

    // replace staged visual media source w/ the new visual media source
    if (isVisualMediaSourceStaged && isVisualMediaSource(source) && !isStaged) {
      // un stage previous visual media source
      delete stagedSources[stagedVisualMediaSource._id];

      stagedSources[sourceId] = true;
    } else {
      stagedSources[sourceId] = !isStaged;
    }

    /**
     * Since AUDIO_FILE should NOT change scene layout,
     * when selected, we just return previously selected layout
     * so UI does not change.
     */
    const sceneLayout = isAudioSource
      ? stagedSceneLayout
      : queueSceneLayoutSelector(stagedSources, broadcastSources);

    const action = {
      type: BROADCAST_TOGGLE_STAGE_SOURCE,
      payload: stagedSources
    };

    batch(() => {
      dispatch(action);
      dispatch(queueStageLayout(sceneLayout));
    });
  };
};
